import React from 'react';

export const Stack: React.FC<React.CSSProperties> = ({ children, ...style }) => {
  return <div style={{ display: 'flex', gap: 5, ...style }}>{children}</div>;
};
